import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import ReactPaginate from "react-paginate";

interface PaginationProps {
  currentPage: number;
  totalPage: number;
  total?: {totalItems: number, total: number };
  hideTotal?: boolean;
  onChange: (item: number) => void;
}
export const Pagination = ({currentPage, totalPage, total, hideTotal, onChange }: PaginationProps) => {

  const handlePageClick = (e: any) => {
    const page = e.selected + 1;
    onChange(page);
  };

  return (
    <div className="max-w-full bg-white box-border">
      <div className="flex items-center justify-center md:justify-between max-w-full">
        <p className="hidden font-medium sm:block text-sm text-gray-700" style={{visibility: hideTotal ? "hidden" : "initial"}}>
         Total: <span>{total?.totalItems}</span> / <span>{total?.total}</span>
        </p>
        {(totalPage && totalPage > 1) ? (
          <ReactPaginate
            breakLabel={<div className='px-3'>...</div>}
            previousLabel={
              <div className="px-1">
                <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" />
              </div>
            }
            nextLabel={
              <div className="px-1">
                <ChevronRightIcon className="h-4 w-4" aria-hidden="true" />
              </div>
            }
            className={"relative inline-flex items-center"}
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={totalPage}
            forcePage={currentPage - 1}
            disableInitialCallback={true}
            pageClassName="text-sm font-semibold hover:cursor-pointer focus:outline-offset-0 px-0.5 select-none"
            activeLinkClassName="bg-magnolia-600 hover:bg-magnolia-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
            pageLinkClassName="text-gray-900 rounded-md px-3 py-1.5 md:px-4 md:py-2 hover:bg-gray-50"  
            renderOnZeroPageCount={null}
          />
        ) : <></>}
      </div>
    </div>
  )
}

export default Pagination;
